import { TenantTypeEnum }        from '@app/modules/admin-tenant/models/tenant.model';
import { TransactionStatistics } from '@app/modules/dashboard/model/transaction.model';
import { ErsStatusStatistics }   from '@app/modules/ers/models/ers.model';
import {
	TssModeStatistics,
	TssStatusStatistics
}                                from '@app/modules/tss/models/tss.model';


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class TenantStatisticsTMO implements ITenantStatistics {
	public organizations?: number = undefined;

	public businessPremises?: number = undefined;

	public ers?: ErsStatusStatistics = new ErsStatusStatistics();

	public tss?: TssStatusStatistics = new TssStatusStatistics();

	public tssPerMode?: TssModeStatistics = new TssModeStatistics();
}

export class GlobalStatisticTMO implements IGlobalStatistics {

	public date?: Date = undefined;

	public environment?: GlobalStatisticEnvironmentEnum = undefined;

	public transactions?: TransactionStatistics = new TransactionStatistics();

	public tenants?: TenantTypeCountStatistics[] = [];

	public organizations?: number = undefined;

	public businessPremises?: number = undefined;

	public ers?: ErsStatusStatistics = new ErsStatusStatistics();

	public tss?: TssStatusStatistics = new TssStatusStatistics();

	public tssPerMode?: TssModeStatistics = new TssModeStatistics();
}

export class TenantTypeCountStatisticsTMO {
	public tenantType?: TenantTypeEnum = undefined;
	public count?: number = undefined;
}

export class GlobalStatisticsTMO {
	public statistics?: GlobalStatistic[] = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class TenantStatistics extends TenantStatisticsTMO {
	public id = 'statistics';
}

export class GlobalStatistics extends GlobalStatisticsTMO {
	public id?: string = undefined; // unique identifier is the statistics date
}

export class GlobalStatistic extends GlobalStatisticTMO {}

export class TenantTypeCountStatistics extends TenantTypeCountStatisticsTMO {}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface ITssStatistics {
	tss?: TssStatusStatistics;

	tssPerMode?: TssModeStatistics;
}

export interface ITenantStatistics extends ITssStatistics {
	ers?: ErsStatusStatistics;
}

export interface IGlobalStatistics extends ITenantStatistics {
	tenants?: TenantTypeCountStatistics[];
}


// ENUMS #############################################################
// API enums *********************************************************
export enum GlobalStatisticEnvironmentEnum {
	PROD = 'prod',
	REF = 'ref'
}


// UI enums *********************************************************
